import React from 'react';
import ReactDOM from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import { HelmetProvider } from 'react-helmet-async';
import * as Sentry from "@sentry/react";
import client from './ApolloProvider';
import './index.css';
import './locale';
import App from './App';

Sentry.init({
  dsn: "https://46a1b4f7d256dad8d272046a7634dc33@o4505790970265600.ingest.us.sentry.io/4511230013669376",
  sendDefaultPii: false,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ApolloProvider>
  </React.StrictMode>,
);
